var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.842773,
    height: 22,
    viewBox: "0 0 21.8428 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M21.8428 11C21.8428 4.9248 16.918 0 10.8428 0C7.28076 0 4.0332 1.71094 2 4.46216L2 2.49121C2 1.93896 1.55225 1.49121 1 1.49121C0.447754 1.49121 0 1.93896 0 2.49121L0 6.99121C0 7.54346 0.447754 7.99121 1 7.99121L1.54639 7.99121C1.63623 8.00342 1.72656 8.00317 1.81396 7.99121L5.5 7.99121C6.05225 7.99121 6.5 7.54346 6.5 6.99121C6.5 6.43896 6.05225 5.99121 5.5 5.99121L3.36914 5.99121C5.01025 3.54126 7.78467 2 10.8428 2C15.8135 2 19.8428 6.0293 19.8428 11C19.8428 11.5522 20.2905 12 20.8428 12C21.395 12 21.8428 11.5522 21.8428 11ZM0 11C0 17.0752 4.9248 22 11 22C14.5483 22 17.7842 20.3025 19.8188 17.5701L19.8188 19.5C19.8188 20.0522 20.2666 20.5 20.8188 20.5C21.3711 20.5 21.8188 20.0522 21.8188 19.5L21.8188 15C21.8188 14.4478 21.3711 14 20.8188 14L20.1851 14C20.1699 13.9998 20.1548 13.9998 20.1401 14L16.3188 14C15.7666 14 15.3188 14.4478 15.3188 15C15.3188 15.5522 15.7666 16 16.3188 16L18.48 16C16.8394 18.4551 14.062 20 11 20C6.0293 20 2 15.9707 2 11C2 10.4478 1.55225 10 1 10C0.447754 10 0 10.4478 0 11Z",
    clipRule: "evenodd",
    fill: "#50964E",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefresh);
export default __webpack_public_path__ + "static/media/ic_refresh.35ec409271cf36804240fb969a07b9dc.svg";
export { ForwardRef as ReactComponent };